/**
 * Shared QuikQ station URL building — same as Stations page / Postman.
 */

export const QUIKQ_BASE = 'https://api.quikq.com/v1';

export const STATION_ENDPOINTS = [
  { path: '/carriers/stations', label: '/carriers/stations' },
  { path: '/stations', label: '/stations' },
  { path: '/drivers/stations', label: '/drivers/stations' },
  { path: '/user/stations', label: '/user/stations' },
  { path: '/carriers/cityStateZipGeo', label: '/carriers/cityStateZipGeo' },
  { path: '/carriers/stationsDetail', label: '/carriers/stationsDetail' },
];

export function newRowId() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

export function defaultQueryRows() {
  return [
    { id: newRowId(), key: 'startCode', value: '', description: 'Account start code' },
    { id: newRowId(), key: 'stationCode', value: '*ANY', description: 'Station code or *ANY' },
    { id: newRowId(), key: 'miles', value: '25', description: 'Radius in miles' },
    { id: newRowId(), key: 'latitude', value: '', description: 'Latitude' },
    { id: newRowId(), key: 'longitude', value: '', description: 'Longitude' },
    { id: newRowId(), key: 'city', value: '', description: 'Optional (with state / ZIP)' },
    { id: newRowId(), key: 'state', value: '', description: '' },
    { id: newRowId(), key: 'zipCode', value: '', description: '' },
  ];
}

export function buildQueryString(rows) {
  const params = new URLSearchParams();
  rows.forEach((r) => {
    const k = String(r.key || '').trim();
    if (!k) return;
    params.append(k, r.value == null ? '' : String(r.value));
  });
  return params.toString();
}

export function buildFullUrl(path, rows) {
  const q = buildQueryString(rows);
  const base = QUIKQ_BASE.replace(/\/$/, '');
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${base}${p}${q ? `?${q}` : ''}`;
}
